import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CACHE_KEYS } from "../../services/local/CacheManager";
import { Store } from "../../entity/Store";

interface StoreManagerState {
  stores: Store[] | null;
}

const initialState: StoreManagerState = {
  stores: null,
};

const storesManagerSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    setAllStore: (state, action: PayloadAction<Store[] | null>) => {
      state.stores = action.payload;
    },
  },
});

export const { setAllStore } = storesManagerSlice.actions;
export default storesManagerSlice.reducer;
